<mat-dialog-content>
  @for (battery of batteries; track battery; let i = $index) {
    @if (i != 0) {
      <mat-divider></mat-divider>
    }
    <dl>
      <dt>ID</dt>
      <dd>{{battery.id}}</dd>
      <dt>Serial</dt>
      <dd>{{battery.serial}}</dd>
    </dl>
  }
</mat-dialog-content>
